module.exports = __webpack_public_path__ + "img/banker-purple-page_900.5a4ce9f4.png";